import Vue from "vue";

export const InvoiceScheduleEventBus = new Vue();
